import { Component, OnInit, Inject, ViewChild } from "@angular/core";
import { UserStateService } from "../../services/user-state.service";
import { authResponse } from '../../models/authResponse';
import { User } from "../../../users/models/user";
import { LoginService } from '../../services/login.service';
import { MessageService } from 'primeng/api';
import { TranslateService } from "@ngx-translate/core";
import { ResetPasswordComponent } from '../../components/reset-password/reset-password.component';

@Component({
  selector: "app-login",
  template: require('./login.component.html'),
  styles: [require('./login.component.sass')]
})
export class LoginComponent implements OnInit {

  firstSignIn: boolean;
  error: string;
  loginError: string;
  userBlocked: boolean;
  firstSignInUser: User;
  updateLoginError: string;

  @ViewChild(ResetPasswordComponent) resetPassword: ResetPasswordComponent;

  constructor(
    @Inject('AuthenticationFactory') private authenticationFactory: any,
    @Inject('StateManagerFactory') private stateManagerFactory: any,
    private userStateService: UserStateService,
    private loginService: LoginService,
    private messageService: MessageService,
    private translate: TranslateService
  ) {}

  ngOnInit(): void {}

  onLogin = async (credentials: { username: string; password: string }) => {
    this.error = '';
    this.loginError = '';

    if (credentials.username && credentials.password) {
      try {
        const authResponse = <authResponse> await this.authenticationFactory.userLogin(credentials.username, credentials.password);
        if (authResponse.firstlogin) {
          this.firstSignIn = true;
          this.firstSignInUser = {
            id: authResponse.id,
            username: authResponse.name,
            name: authResponse.fullname,
            admin: authResponse.admin,
            firstlogin: authResponse.firstlogin,
            token: authResponse.token
          };
        } else {
          this.stateManagerFactory.proceedOnLogin();
        }
        
      } catch (error) {
        const status = error && error.status;
        let errorMessage = "I18N_LOGIN.FAILED";
        switch (status) {
            case 403:
              errorMessage = "I18N_LOGIN.FAILED";
              break;
            default:
              errorMessage = error.data;
              break;
        }
        this.error = errorMessage;
        this.loginError = errorMessage;
        this.userBlocked = this.userStateService.checkForUserBlock(error);
      }
    } else {
      this.error = "I18N_LOGIN.FILL_IN_PASSWORD";
      this.loginError = "I18N_LOGIN.FILL_IN_PASSWORD";
    }
  };

  onPasswordUpdated = async (credentials: {newPassword: string; confirmPassword: string}) => {
    if (credentials.newPassword  && credentials.confirmPassword && (credentials.newPassword === credentials.confirmPassword)) {
        const tempAuthenticationUser = {
            username: this.firstSignInUser.username,
            password: credentials.newPassword,
            token: this.firstSignInUser.token
        };
        try {
          await this.loginService.updateFirstLoginPassword(tempAuthenticationUser);
          this.messageService.add({
            severity:'success',
            summary: this.translate.instant("I18N_AUTH.PASSWORD_UPDATE"),
            detail:`${this.translate.instant("I18N_AUTH.PASSWORD_FOR_USER")} ${this.firstSignInUser.name} ${this.translate.instant("I18N_GENERAL.HAS_BEEN_SUCCESSFULLY_UPDATED")}. 
                    ${this.translate.instant("I18N_AUTH.YOU_MAY_NOW_LOGIN")} `
          });
          this.firstSignIn = false;
        } catch (error) {
          this.updateLoginError = "I18N_LOGIN.COULD_NOT_AUTHORIZE";
        }
        
    } else {
        this.updateLoginError = "I18N_LOGIN.PASSWORDS_NOT_VALID";
    }
  };

  requestResetPassword = async () => {
    await this.resetPassword.showModal();
  }

  onResetPassword = async (email: string) => {
    try {
      await this.loginService.resetPasswordByEmail(email);
      this.messageService.add({
        severity:'success', 
        summary: this.translate.instant("I18N_LOGIN.PASSWORD_RECOVERY"),
        detail:`${this.translate.instant("I18N_LOGIN.EMAIL_SENT_TO")} ${email}`
      });
    } catch (error) {
      this.messageService.add({
        severity:'danger', 
        summary: this.translate.instant("I18N_LOGIN.PASSWORD_RECOVERY"),
        detail:error && error.message
      });
    }

  }
}
